var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"react-face"},[_c('span',{class:_vm.reactFace.className}),_c('div',{staticClass:"text-small"},[_c('p',[_vm._v(_vm._s(_vm.reactFace.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }